<template>
  <div>
    <v-card class="main-container">
      <v-card-title style="color:gray; font-weight:bold; padding-left: 0px;">

        <div style="width: 1000px; margin-left: 20px;">

          <v-tabs v-model="activeTab"  fixed-tabs>
            <v-tab :key="0">Текущие</v-tab>
            <v-tab :key="1">Архив</v-tab>
          </v-tabs>
        </div>
      </v-card-title>

      <v-card-text>
        <v-list class="d-flex align-center justify-start">
          <v-list-item>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #ef0000  !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                {{ 'Горит!)' }}
            </v-btn>
          </template>
            <span>Новый запрос. Обратите внимание на сроки, даты посещения уже близко</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="background-color: #a9a9a9 !important;"
                  @click=""
                  v-bind="attrs"
                  v-on="on"
                  x-small
                >
                  Новый запрос
                </v-btn>
              </template>
              <span>"Возьмите в работу" или "Отклоните" если BS указал некорректные или недостаточные данные</span>
            </v-tooltip>
          </v-list-item>

          <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #ada509 !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                В работе
            </v-btn>
          </template>
            <span>{{ 'После оформления пропуска нажмите "Оформлен", гости и BS узнают, что все готово)' }}</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #1b8e30 !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                Готов
            </v-btn>
          </template>
            <span>Спасибо! После завершения действия пропуска он перейдет в Архив</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #E57373  !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                Отменен
            </v-btn>
          </template>
            <span>Пропуск не оформлен</span>
            </v-tooltip>
          </v-list-item>
        </v-list>

        <v-tabs-items>
          <v-data-table
            :style="{color: $mainColor}"
            :headers="current_headers"
            :items="listPasses"
            :loading="preloaderYet"
            :loading-text="$t('User.loading_orders')"
            :items-per-page="20"
            :footer-props="{
                itemsPerPageOptions: [10, 20, 100],
                itemsPerPageText: 'кол-во на стр.:',
            }"
          >
            <template v-slot:item.id="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">
                {{ item.id }}
              </span>
            </template>
            <template v-slot:item.start_date="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">

                <v-chip
                  :color="get_color(item)"
                  dark
                >
                  {{ g.toDateTime(item.start_date) }} - {{ g.toDateTime(item.finish_date) }}
                </v-chip>
                <!-- {{ g.toDateTime(item.start_date) }} - {{ g.toDateTime(item.finish_date) }} -->
                <!-- {{ g.toDate(item.start_date) - g.toDate(item.finish_date) }} -->
              </span>
            </template>
            
            <template v-slot:item.station="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">
                {{ item.station_from_proposal ? item.station_from_proposal : (item.station_from_calendar ? item.station_from_calendar : 'нет информации') }}
              </span>
            </template>

            <template v-slot:item.proposal_id="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">
                #{{ item.proposal_id }}
              </span>
            </template>

            <template v-slot:item.init_by="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">
                {{ item.creator }}
                <br>
                {{ item.creator_phone }}
              </span>
            </template>
            <template v-slot:item.create_date="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">
                {{ g.toDate(item.created_at) }}
              </span>
            </template>
            


            <!-- <template v-slot:item.name="{ item }">
              <v-tooltip v-if="item.last_status_id == 1" right>
                  <span>{{$t('need_modification')}}</span>
              </v-tooltip>
              <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                {{ item.name ? item.name: $t('untitled') }}
              </span>
            </template> -->

            <!-- <template v-slot:item.actions="{ item }">
              <v-icon
                v-if="activeTab === 0"
                class="ma-2"
                small
                color="green lighten-1"
                @click="dialogConfirmDone = true; current_pass_id = item.id">
                mdi-check-underline
              </v-icon>
              <v-icon
                v-if="activeTab === 0"
                class="ma-2"
                small
                color="red lighten-1"
                @click="dialogConfirmPrint = true; current_pass_id = item.id; print_type = 1">
                mdi-printer
              </v-icon>
              <v-icon
                v-if="activeTab === 0"
                class="ma-2"
                small
                color="red lighten-1"
                @click="dialogConfirmPrint = true; current_pass_id = item.id;  print_type = 2">
                mdi-printer-outline
              </v-icon>
              <v-icon
                v-if="activeTab === 0"
                class="ma-2"
                small
                color="red lighten-1"
                @click="dialogConfirmDelete = true; current_pass_id = item.id">
                mdi-delete
              </v-icon>
            </template> -->
          </v-data-table>
        </v-tabs-items>            
      </v-card-text>
    </v-card>

    <v-dialog v-model="pass_card_dialog" max-width="75%">
      <pass-modal-card
        @updateParent="update_parent($event.item, $event.close_modal)"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import passModalCard from '../components/Common/Pass/modalCard.vue'

export default {
  name: 'Passes',

  components: {
    passModalCard
  },

  data() {
    return {
      current_headers: [],
      headers_base: [
          { text: 'ID', sortable: true, value: 'id'},
          { text: 'Даты', sortable: true, value: 'start_date'},
          { text: 'ФИО гостей', sortable: true, value: 'guests'},
          { text: 'Станция', sortable: false, value: 'station'},
          { text: 'Proposal', sortable: false, value: 'proposal_id'},
          { text: 'Инициатор', sortable: false, value: 'init_by'},
          { text: 'Дата создания', sortable: true, value: 'create_date'},
          // { text: 'Действия', sortable: false, value: 'actions'},
      ],
      listPasses: [],

      preloaderYet: false,
      activeTab: 0,
      print_type: 1,

      dialogConfirmPrint: false,
      dialogConfirmDelete: false,
      dialogConfirmDone: false,

      pass_card_dialog: false,
      current_pass_id: 0,

      red_date: new Date(),
    };
  },

  async beforeMount() {
      this.current_headers = this.headers_base
      this.activeTab = 0

      this.red_date.setDate(this.red_date.getDate() + 2)
      var mm = this.red_date.getMonth() + 1;
      mm = Number(mm) < 10 ? `0${mm}` : mm
      var dd = this.red_date.getDate() 
      dd = Number(dd) < 10 ? `0${dd}` : dd

      this.red_date =  this.red_date.getFullYear() + '-' + mm + '-' + dd; 

    this.loadNewRequest();
  },

  methods:{
    ...mapActions([
      'GET_LIST_PASSES',
      'GET_PASS_ALL',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),


    get_color(item){
      if(item.status == 2)
        return '#1b8e30'
      else if(item.status == 3)
        return '#e57373'
      else if(item.status == 1)
        return '#ada509'
      else if(item.status == 5)
          return '#794606'
      else if(item.status == 0 || item.status == 4){
        console.log('get_color', this.red_date, item.start_date.split('T')[0])
        if(item.start_date.split('T')[0] > this.red_date)
          return '#a9a9a9'
        else
          return '#ef0000'
      }
      else
        return 'yellow'


    },

    openDetailInfo(pass){
      this.current_pass_id = pass.id
      this.UPDATE_OVERLAY(true)
      console.log('show_pass_card', pass)
      this.GET_PASS_ALL(this.current_pass_id)
        .then(() => {
          this.UPDATE_OVERLAY(false)
          this.pass_card_dialog = true
        })        
    },

    update_parent(item, close_modal = true) {
      if(close_modal)
        this.pass_card_dialog = false;
      if(item == -1)
        this.loadNewRequest()

      this.GET_PASS_ALL(this.current_pass_id)
    },

    loadNewRequest() {
      this.preloaderYet = true;
      this.listPasses = [];

      this.GET_LIST_PASSES({status_id: this.activeTab, view_type: 'admin'})
        .then((res) => {
          this.preloaderYet = false;
          this.listPasses = res.data;
        })
        .catch(() => this.preloaderYet = false);
    },
  },

  computed: mapGetters(['GETTERS_LOGIN']),

  watch: {
    activeTab(val) {
      this.loadNewRequest(val)
    },
  }

};
</script>
